/**
 * Local Copenhagen clock for Clinio Pay.
 * Swap this for the shared clinic date helper when that lands (draft #481).
 */
const COPENHAGEN = 'Europe/Copenhagen';

function localeFor(language: string): string {
  return language.startsWith('da') ? 'da-DK' : 'en-GB';
}

export function formatPayClock(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(localeFor(language), {
    timeZone: COPENHAGEN,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}

export function formatPayDateTime(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(localeFor(language), {
    timeZone: COPENHAGEN,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}
